var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.badgeClass},[_vm._t("default"),(_setup.showBadge)?_c('sup',{staticClass:"tui-badge-count"},[_vm._v(_vm._s(_setup.content))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }